import type { ReactNode } from 'react';
import { PlusCircle } from 'react-feather';
import styled from '@emotion/styled';

export type AddButtonProps = {
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
};

export function AddButton({ onClick, children, disabled, className }: AddButtonProps): React.JSX.Element {
  return (
    <StyledAddButton type="button" onClick={onClick} disabled={disabled} className={className}>
      <PlusCircle size={14} />
      {children}
    </StyledAddButton>
  );
}

const StyledAddButton = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  marginTop: 8,
  padding: '6px 12px',
  fontSize: 14,
  fontWeight: 600,
  color: 'var(--pri-01)',
  backgroundColor: 'var(--pri-02)',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  transition: 'opacity 0.15s ease',
  '&:hover': {
    opacity: 0.85,
  },
});
